import { SUPPORT_EMAIL_MAIL_TO } from "@/constants"
import { Component } from "@/types/types"
import { ButtonLink } from "@/ui/atoms/controls/ButtonLink"
import { TextLink } from "@/ui/atoms/controls/TextLink"
import { SplashCard } from "@/ui/atoms/layout/SplashCard"
import { Stack } from "@/ui/atoms/layout/Stack"
import { Icon } from "@/ui/atoms/media/Icon"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { Title } from "@/ui/atoms/type/Title"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "demoSignupDisabledNotice"

export const presets = {}

export interface Props extends Component {}

export function DemoSignUpDisabledNotice({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <SplashCard className={cx(`w-full max-w-screen-form text-center`, className)} testId={testId}>
      <Stack className="gap-8">
        <header>
          <Stack className="gap-6 items-center">
            <Icon name="warningXl" className="text-icon-warning size-20" />
            <Title size="lg" className="text-center">
              Course preview not available
            </Title>

            <BodyText size="md">
              The SANS Foundations preview experience is currently at capacity. Please try again
              later.
            </BodyText>
          </Stack>
        </header>
      </Stack>
    </SplashCard>
  )
}
